import { View } from '@react-pdf/renderer';
import Html from 'react-pdf-html';
import {
  RDateCity,
  RHeader,
  RPage,
  RViewer,
} from '../../../components/PdfRender';
import { useCompany } from '../../../hooks/company';
import * as S from './styles';

export interface ICrcReportProps {
  htmlContent?: string | null;
  periodFrom?: string | null;
  periodTo?: string | null;
  reportType?: string | null;
}

const getResolvedDate = (val?: string | null): string | undefined => {
  if (!val) return undefined;
  try {
    return new Date(val).toISOString();
  } catch {
    return undefined;
  }
};

const sanitizeHtmlForPdf = (html: string): string => {
  let safe = typeof html === 'string' ? html : '';
  safe = safe.replace(
    /font-family\s*:\s*[^;"']*/gi,
    'font-family: Helvetica',
  );
  safe = safe.replace(/font-family\s*=\s*"[^"]*"/gi, 'font-family="Helvetica"');
  safe = safe.replace(/font-family\s*=\s*'[^']*'/gi, "font-family='Helvetica'");
  safe = safe.replace(/border-collapse\s*:\s*[^;"']*/gi, 'border-collapse: separate');
  safe = safe.replace(/border-collapse\s*=\s*"[^"]*"/gi, 'border-collapse="separate"');
  safe = safe.replace(/border-collapse\s*=\s*'[^']*'/gi, "border-collapse='separate'");
  safe = safe.replace(/border-spacing\s*:\s*[^;"']*/gi, '');
  safe = safe.replace(/border-spacing\s*=\s*"[^"]*"/gi, '');
  safe = safe.replace(/border-spacing\s*=\s*'[^']*'/gi, '');
  return safe;
};

export const CrcReport: React.FC<ICrcReportProps> = ({
  htmlContent,
  periodFrom,
  periodTo,
  reportType,
}) => {
  const { company } = useCompany();
  const issueDate = getResolvedDate(periodTo) ?? getResolvedDate(periodFrom);

  const safeHtml =
    typeof htmlContent === 'string' && htmlContent.trim().length > 0
      ? sanitizeHtmlForPdf(htmlContent)
      : `<div>
           <h1 style="color:#1677ff;font-size:20px;font-family:Helvetica;">Relatório CRC - ${String(reportType || 'OVERVIEW').toUpperCase()}</h1>
           <p style="color:#666;font-size:12px;font-family:Helvetica;">Nenhum conteúdo disponível para exibição.</p>
         </div>`;

  return (
    <RViewer>
      <RPage size="A4" orientation="portrait">
        <View style={S.styles.container}>
          <RHeader company={company ?? null} />
          <View style={S.styles.content}>
            <Html style={S.styles.html}>{safeHtml}</Html>
          </View>
          <RDateCity company={company ?? null} issueDate={issueDate} />
        </View>
      </RPage>
    </RViewer>
  );
};

export default CrcReport;
